import React from "react";
import { TypeAnimation } from "react-type-animation";
import { Link } from "react-scroll";

function Home() {
  const handleDownload = (e) => {
    e.preventDefault();
    const link = document.createElement("a");
    link.href = "/CV/MahinMalek_Resume.pdf";
    link.download = "MahinMalek_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.open("/CV/MahinMalek_Resume.pdf", "_blank");
  };
  return (
    <section
      className=" min-h-screen h-fit bg-gray-light flex justify-center items-center  dark:bg-[#001840] py-20"
      id="HOME"
    >
      <div className="md:w-3/4  m-auto grid md:flex justify-between items-center gap-5 md:gap-0">
        <div className="text-gray-800 grid grid-cols-1 gap-3 dark:text-white m-auto md:m-0 md:w-1/2 w-3/4 ts:w-full">
          <h2 className="font-Ubuntu vs:text-2xl font-semibold tracking-wide ts:text-3xl">
            Hello,<span> My name is </span>
          </h2>
          <h1 className="font-Rubik ts:text-6xl vs:text-4xl font-semibold tracking-wide leading-snug">
            Mahin Malek
          </h1>
          <h3 className="font-Ubuntu vs:text-lg font-semibold ts:text-2xl md:text-4xl flex items-center gap-2">
            I'm a
            <span className="text-common-red font-semibold">
              <TypeAnimation
                preRenderFirstString={true}
                sequence={[
                  500,
                  "MERN Developer!!",
                  1000,
                  "Versatile Achiever✨", // initially rendered starting point
                  1000,
                  "Continuous Learner...",
                  1000,
                  "Problem Solver💡",
                  1000,
                  "Tech Visionary 💻",
                  1000,
                  "Creative Thinker>>>",
                  1000,
                  "Articulate Presenter^^",
                  1000,
                  "dreamer on a mission",
                  1000,
                  "Effective Communicator++",
                  500,
                ]}
                speed={50}
                // style={{ fontSize: '2em' }}
                repeat={Infinity}
              />
            </span>
          </h3>
          <h2 className="my-2 font-Lemon">
            Open for Freelancing Projects!{" "}
            <Link
              activeClass="active"
              to="CONTACT"
              spy={true}
              smooth={true}
              offset={-60}
              duration={500}
            >
              {" "}
              <code className="text-common-red underline cursor-pointer hover:no-underline">
                Contact Now..
              </code>
            </Link>{" "}
          </h2>
          <div className="py-3">
            <a
              href="/CV/MahinMalek_Resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              download="MahinMalek_Resume.pdf"
              onClick={handleDownload}
            >
              <button className="cursor-pointer hover:bg-gray-light hover:text-common-red hover:border-2 hover:border-common-red bg-common-red text-white p-2 px-3 rounded-md h-12 w-36 font-Ubuntu text-xl font-medium tracking-wide transition-all duration-500">
                Resume
              </button>
            </a>
          </div>
        </div>
        <div className="max-w-fit w-3/4 md:w-1/3 m-auto order-first md:order-last my-10 md:my-0">
          <img
            loading="eager"
            decoding="async"
            id="main_img"
            className="border-4 dark:shadow-[#1e386b_12px_8px_5px_5px] shadow-[#dc143c_12px_8px_5px_5px] z-20 rounded-full transform transition-transform duration-1000 ease hover:scale-[1.10]"
            src={"/Images/myPhoto.jpg"}
            alt="Home page"
          />
        </div>
      </div>
    </section>
  );
}

export default Home;
